'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/ref.js
// module id = 1167
// module chunks = 44